import * as Sentry from "@sentry/browser";

const initSentry = () => {
  const dsnMeta = document.querySelector('meta[name="sentry-dsn"]');
  const envMeta = document.querySelector('meta[name="sentry-env"]');
  const userIdMeta = document.querySelector('meta[name="sentry-user-id"]');

  if (!dsnMeta || !dsnMeta.content) return;

  const posthogSessionUrl = () => {
    try {
      if (window.posthog && typeof window.posthog.get_session_replay_url === "function") {
        return window.posthog.get_session_replay_url();
      }
    } catch (_e) {}

    return null;
  };

  Sentry.init({
    dsn: dsnMeta.content,
    environment: envMeta ? envMeta.content : "production",
    tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE || "0.05"),

    // Ignore common browser extension and third-party script noise
    ignoreErrors: [
      // Browser extensions
      "top.GLOBALS",
      "webkitContextMenu",
      "fb_xhtml_fragment",
      // Chrome extension messaging (no stacktrace/URL, so denyUrls can't catch
      // it): thrown by chrome.runtime.sendMessage when the receiving content
      // script / service worker is gone (RUBY-RAILS-19F).
      "Could not establish connection. Receiving end does not exist.",
      "The message port closed before a response was received.",
      // Cross-origin script errors
      "Script error.",
      // rails-ujs evals remote responses as <script>; mobile proxies truncate the body
      /SyntaxError.*Failed to execute 'appendChild' on 'Node'/,
    ],
    denyUrls: [
      // Chrome/Safari extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^safari-extension:\/\//i,
      // Facebook, Google, Bing tracking scripts (cannot patch vendor scripts)
      /connect\.facebook\.net/i,
      /google-analytics\.com/i,
      /googletagmanager\.com/i,
    ],

    beforeSend(event) {
      // Safely link PostHog session replay URL if available
      const sessionUrl = posthogSessionUrl();
      if (sessionUrl) {
        event.tags = event.tags || {};
        event.tags["posthog_session_url"] = sessionUrl;
      }

      return event;
    },
  });

  if (userIdMeta && userIdMeta.content) {
    Sentry.setUser({ id: userIdMeta.content });
  }

  const sessionUrl = posthogSessionUrl();
  if (sessionUrl) {
    Sentry.setTag("posthog_session_url", sessionUrl);
  }
};

const safelyInitSentry = () => {
  try {
    initSentry();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("[Sentry] Failed to initialize frontend SDK", e);
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", safelyInitSentry, { once: true });
} else {
  safelyInitSentry();
}

export default Sentry;
